import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    paddingTop: '$lg',
    paddingLeft: `$sm`,
    paddingRight: `$sm`,
    '@md': {
        paddingTop: '$xl',

        paddingLeft: `calc(5 * $colWidth)`,
        paddingRight: `calc(5 * $colWidth)`,
    },
})

export const Column = styled('div', {
    '@md': {
        width: '50%',

        '&:last-child': {
            marginTop: '$xxl',
        },
    },
})

export const ColumnsWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '$sm',
    '@md': {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: `calc(3 * $colWidth)`,
    },
    variants: {
        noMargin: {
            true: {
                '@md': {
                    [`${Column}`]: {
                        marginTop: 0,
                    },
                },
            },
        },
    },
})
